// Angular
import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, ViewChild } from '@angular/core'
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms'
// Other.
import { from as observableFrom, merge as observableMerge, Subscription, Subject, Observable } from 'rxjs'
import { switchMap, debounceTime, distinctUntilChanged } from 'rxjs/operators'
import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap'
// Service models.
import { Site } from '@app/modules/site/site.model'
import { SiteService } from '@app/modules/site/site.service'
import { SiteFormService } from '@app/modules/site/site-form.service'

@Component({
  selector: 'app-site-typeahead',
  templateUrl: './site-typeahead.component.html'

})

export class SiteTypeaheadComponent implements OnInit, OnDestroy {

  /**
   * Display page
   */
  public display: boolean

  /**
   * Main form
   */
  @Input() mainForm: FormGroup

  /**
   * Main form change
   */
  @Output() mainFormChange: EventEmitter<FormGroup> = new EventEmitter<FormGroup>()

  /**
   * Button text
   */
  @Input() mainFormControlName: string

  /**
   * Button text
   */
  @Input() buttonText: string

  /**
   * Button text
   */
  @Input() iconClass: string

  /**
   * Company primary key
   */
  @Input() companyUuid: FormGroup

  /**
   * Selected form
   */
  public selectedForm: FormGroup

  /**
   * Mode
   *
   * 'single' or 'array'
   */
  @Input() mode?: string

  /**
   * Subscriptions
   */
  private subscriptions: Array<Subscription> = []

  @ViewChild('siteSearchTypeAhead') siteSearchTypeAhead: NgbTypeahead
  public focus$: Subject<string> = new Subject<string>()
  public click$: Subject<string> = new Subject<string>()

  /**
   * Constructor
   */
  public constructor (
    private formBuilder: FormBuilder,
    private siteService: SiteService,
    private siteFormService: SiteFormService
  ) {}

  /**
   * On destroy
   */
  public ngOnDestroy (): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe()
    })
  }

  /**
   * On init
   */
  public ngOnInit (): void {
    this.display = false
    this.selectedForm = this.formBuilder.group({
      selectedItem: [
        null,
        [
          Validators.required
        ]
      ]
    })
    this.display = true
  }

  /**
   * Search
   *
   * @type {function}
   *
   * @returns {Array<any>}
   */
  public search: any = (text$: Observable<string>): Observable<any> => {
    const debouncedText: Observable<string> = text$.pipe(debounceTime(500), distinctUntilChanged())

    return observableMerge(debouncedText)
    .pipe(
      switchMap(term => observableFrom(this.getResults(term)))
    )
  }

  /**
   * Search result formatter
   *
   * Converts the object into a readable string.
   *
   * @type {any}
   *
   * @returns {string}
   */
  public formatResults: any = (item: any): any => {
    const strParts: Array<any> = []
    // const name: Array<any> = []

    if (item.name) {
      strParts.push(item.name)
    }
    // const addressParts: Array<any> = []
    if (item.addresses && item.addresses.length > 0) {
      if (item.addresses[0].address1) {
        strParts.push(item.addresses[0].address1)
      }
      if (item.addresses[0].city) {
        strParts.push(item.addresses[0].city)
      }
      if (item.addresses[0].state) {
        strParts.push(item.addresses[0].state)
      }
      if (item.addresses[0].postcode) {
        strParts.push(item.addresses[0].postcode)
      }
    }

    return strParts.join(', ')
  }

  /**
   * Select item
   *
   * @param {Event} $event Event
   */
  public selectItem ($event: Event): void {
    if ($event) {}
    // console.log('selectItem', $event)
  }

  /**
   * Is search valid
   *
   * @returns {boolean}
   */
  public isSearchValid (): boolean {
    if (this.selectedForm.get('selectedItem').value && this.selectedForm.get('selectedItem').value.uuid) {
      return true
    }
    return false
  }

  /**
   * Add schedule contact
   */
  public add (): void {
    console.log(this.mode)
    if (this.mode === 'single') {
      const control: FormGroup = this.mainForm.get('site') as FormGroup

      const site: Site = new Site(this.selectedForm.get('selectedItem').value)

      if (!control) {
        this.mainForm.addControl('site', this.siteFormService.getForm(site, ''))
      }

      if (control) {
        control.reset()
      }

      this.mainForm.patchValue({
        siteUuid: site.uuid,
        site: site
      })

      console.log('app-site-typeahead mainForm', this.mainForm.value)

    } else {
      const control: FormArray = this.mainForm.get('site') as FormArray
      const site: Site = new Site(this.selectedForm.get('selectedItem').value)
      const siteForm: FormGroup = this.siteFormService.getForm(site, 'new')
      control.push(siteForm)

      this.selectedForm.patchValue({
        selectedItem: null
      })
    }
  }

  /**
   * Searcher
   *
   * @param term Search term
   */
  public getResults (term: string): Promise<any> {
    const params: any = {
      limit: 50,
      sort: [
        {
          key: 'name',
          direction: 'ASC'
        }
      ],
      filter_groups: [
        {
          or: true,
          filters: [
            {
              key: 'name',
              value: term,
              operator: 'ct'
            }
          ]
        },
        {
          filters: [
            {
              key: 'company_uuid',
              value: this.companyUuid,
              operator: 'eq'
            }
          ]
        }
      ],
      includes: [
        'addresses'
      ]
    }

    return this.siteService.api.getMany(params)
    .toPromise()
    .then((results) => {
      return results
    })
  }
}
